module.exports = __webpack_public_path__ + "img/1.cc647337.jpg";